(function () {
  if (window.__glpStickyHeadLp) return;
  window.__glpStickyHeadLp = true;

  var DELTA = 6;

  function init() {
    var bar = document.querySelector("[data-lp-stickyhead]");
    if (!bar) return;
    var spacer = document.querySelector("[data-lp-stickyhead-spacer]");

    var lastY = window.scrollY;
    var pinned = false;
    var threshold = 0;
    var ticking = false;

    function measure() {
      if (pinned) return;
      threshold = bar.offsetTop + bar.offsetHeight;
      if (spacer) spacer.style.height = bar.offsetHeight + "px";
    }

    function pin(on) {
      if (on === pinned) return;
      pinned = on;
      bar.classList.toggle("glp-logobar--pinned", on);
      if (spacer) spacer.classList.toggle("is-on", on);
      if (on) {
        window.requestAnimationFrame(function () {
          if (pinned) bar.classList.add("is-anim");
        });
      } else {
        bar.classList.remove("is-anim");
        bar.classList.remove("is-visible");
      }
    }

    function update() {
      ticking = false;
      var y = window.scrollY;

      if (y <= threshold) {
        pin(false);
        lastY = y;
        return;
      }

      pin(true);
      var delta = y - lastY;
      if (Math.abs(delta) < DELTA) return;
      bar.classList.toggle("is-visible", delta < 0);
      lastY = y;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    measure();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () {
      var was = pinned;
      pin(false);
      measure();
      if (was && window.scrollY > threshold) pin(true);
    });
    update();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector("[data-lp-stickyhead]")) {
      window.__glpStickyHeadLp = false;
      init();
      window.__glpStickyHeadLp = true;
    }
  });
})();
